import { motion } from "framer-motion";
import { Award } from "lucide-react";
import { useT } from "@/i18n";
import { LumiMascot, SparkMascot } from "@/components/Mascots";
import { MISSIONS, APP_TEXT } from "@/components/appbuilder/missions";

export const AppHeader = ({ done }) => {
  const { lang } = useT();
  const tx = APP_TEXT[lang];
  return (
    <div className="grid grid-cols-[auto_1fr_auto] items-center gap-2">
      <LumiMascot className="w-20 sm:w-32" />
      <div className="text-center">
        <h2 className="font-fredoka text-3xl sm:text-5xl font-bold leading-tight">
          <span className="bubble-text text-yellow-300">{tx.titleA} </span>
          <span className="bubble-text text-cyan-300">{tx.titleB}</span>
        </h2>
        <p className="mt-2 inline-block bg-white/90 rounded-full px-4 py-1.5 text-xs sm:text-base font-bold text-blue-900 shadow" data-testid="app-lab-subtitle">{tx.lab}</p>
        <div className="mt-3 max-w-sm mx-auto">
          <div className="h-4 bg-white/70 rounded-full overflow-hidden border-2 border-white">
            <motion.div className="h-full bg-gradient-to-r from-yellow-300 to-lime-400" animate={{ width: `${(done.length / MISSIONS.length) * 100}%` }} />
          </div>
          <p className="mt-1 text-sm font-bold text-blue-950" data-testid="app-mission-progress">{done.length}/{MISSIONS.length} {tx.progress}</p>
        </div>
      </div>
      <SparkMascot className="w-20 sm:w-32" />
    </div>
  );
};

export const RewardPop = ({ show }) => {
  const { lang } = useT();
  if (!show) return null;
  return (
    <motion.div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none" initial={{ opacity: 0 }} animate={{ opacity: 1 }} data-testid="mission-reward">
      <motion.div className="bg-yellow-300 border-8 border-white rounded-[2rem] px-10 py-6 shadow-2xl text-center" initial={{ scale: 0.3, rotate: -10 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", stiffness: 220 }}>
        <img src="/img/lumi.webp" alt="" className="w-24 mx-auto mascot-wiggle" />
        <p className="font-fredoka text-3xl font-bold text-blue-950">{APP_TEXT[lang].reward}</p>
      </motion.div>
    </motion.div>
  );
};

export const FinalBadge = () => {
  const { lang } = useT();
  const tx = APP_TEXT[lang];
  return (
    <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="bg-gradient-to-br from-yellow-200 to-amber-300 border-4 border-white rounded-[2rem] p-6 shadow-xl flex items-center gap-4" data-testid="app-final-badge">
      <div className="bg-white rounded-full p-4 shadow-lg"><Award className="w-12 h-12 text-amber-500" /></div>
      <div>
        <p className="font-fredoka text-2xl sm:text-3xl font-bold text-blue-950">{tx.badge}</p>
        <p className="font-semibold text-blue-900">{tx.badgeSub}</p>
      </div>
    </motion.div>
  );
};
